import { render, staticRenderFns } from "./add_remark.vue?vue&type=template&id=44c6e54d&scoped=true&"
import script from "./add_remark.vue?vue&type=script&lang=js&"
export * from "./add_remark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c6e54d",
  null
  
)

export default component.exports